module.exports = __webpack_public_path__ + "media/images/premium/coin-3ffc8bfd93e83fa0612deb213f216a6f.png";